export default "__VITE_ASSET__CngfC09L__"